import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MaintenanceType, Problem, Segment } from '@core/interfaces';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { sentry } from 'sentry';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

const SEARCH_QUERY = gql`
  query searchCompanies($where: ProblemWhereInput) {
    problems(
      where: $where
      orderBy: {
        column: name,
        direction: asc
      }
      limit: 100
      offset: 0
    ){
      items {
        id
        name
      }
    }
  }
`;

@Component({
  selector: 'fc-problem-input',
  templateUrl: './fc-problem-input.component.html',
  styleUrls: ['./fc-problem-input.component.scss']
})
export class FcProblemInputComponent {

  @Input()
  public control: FormControl;

  @Input()
  public options = [];

  @Input()
  public disabled: boolean;

  @Input()
  public segmentId: Segment;

  @Input()
  public maintenanceTypeId: MaintenanceType;

  @Input()
  public showSearchIcon = false;

  @Input()
  public requiredMark = false;

  @Input()
  public preloadOptions = false;

  @Input()
  public searchOnFocus = false;

  @Input()
  public translateErrorPrefix: string;

  constructor(
    private readonly fuseTranslationLoaderService: FuseTranslationLoaderService,
    private readonly apollo: Apollo
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
    this.search = this.search.bind(this);
    this.displayWith = this.displayWith.bind(this);
  }

  async search(searchTerm: string): Promise<Problem[]> {
    return this.apollo
      .query({
        query: SEARCH_QUERY,
        variables: {
          where: {
            name_contains: searchTerm,
            archived: false,
            segmentId_in: this.segmentId || undefined,
            maintenanceTypeId_in: this.maintenanceTypeId || undefined
          },
        },
      })
      .toPromise()
      .then((result) => result.data['problems']['items'])
      .catch((err) => {
        sentry.captureException(err);
        return [];
      });
  }

  displayWith(value: Problem): string {
    return value && value.name;
  }
}
